import { RefObject } from 'react';
import { IconName } from '../UI/Icon/Icon.types';

export enum NavigationElementType {
    Desktop = 'desktop',
    Mobile = 'mobile',
}

export enum NavigationPosition {
    Absolute = 'absolute',
    Fixed = 'fixed',
}

export type NavigationElement = {
    text: string;
    icon?: IconName;
    className?: string;

    /** Если есть to, то отрендерится Link, иначе кнопка с onClick */
    to?: string;
    onClick?: () => void;

    /** Для фиолетовых кнопок */
    accent?: boolean;

    /** Для выделения текущей кладки */
    active?: boolean;

    /** Для блокировки кнопки */
    disabled?: boolean;

    /** Отображать поповер после нажатия */
    usePopover?: boolean;
    popoverContent?: React.ReactNode;
    autoClosePopover?: boolean;
    popoverClassName?: string;
};

export type NavigationElements = {
    [NavigationElementType.Desktop]: NavigationElement[];
    [NavigationElementType.Mobile]: NavigationElement[];
};

export type NavigationProps = {
    elements: NavigationElements;
    footerRef?: RefObject<HTMLDivElement | null>;
};

export type NavigationPositionState = {
    position: NavigationPosition;
    bottom: number;
};

export type UseNavigationPositionOptions = {
    footerRef?: RefObject<HTMLDivElement | null>;
};
